require('./bootstrap');

window.Vue = require('vue');
window.Vue.debug = true;
